import type { UnknownCharacteristic } from '../../schema';
import { useTranslation } from '../../i18n';

export function UnknownView({ characteristic }: { characteristic: UnknownCharacteristic }) {
    const { t } = useTranslation();
    return (
        <div className="cfg-unknown">
            {t('unknown.warning', { type: characteristic.originalType })}
        </div>
    );
}
